<template>
  <div class="MilestoneReport">
    <div class="main-content" v-if="!isUserGroupAdmin">
      <milestone-grid-tab @clickedTab="selectedTab"></milestone-grid-tab>
      <report-group-filter-bar @selectedGroupObj="setGroupObj" v-bind:showExport="showExportButton" @isExportBtnClicked="exportCSV" @isViewBtnClicked="updateViewBtnClickedFlag" v-if="parseInt(this.currentSelectedTab) === 1"></report-group-filter-bar>
      <milestone-wise-filter-bar @selectedMilestoneInfoAndGroupObj="setMilestoneInfoAndGroupObj" v-bind:showExport="showExportButton" @isExportBtnClicked="exportCSV" @isViewBtnClicked="updateViewBtnClickedFlag" v-if="parseInt(this.currentSelectedTab) === 2"></milestone-wise-filter-bar>
      <hr width="94%" size="10px">
      <div class="row milestoneList margin-Top-2Perc">
        <div class="col-md-12 col-lg-12 width-97Point4 margin-left-1point5Perc">
          <sortable-list v-if="showMilestoneList" v-bind:responseObj="getReportArr" v-bind:sortableColumnName="sortColumnNames" v-bind:columnNameToShow="columnNameToShow" v-bind:linkColumnName="linkColumnNames" v-bind:selectedsubOption="10"></sortable-list>
        </div>
      </div>
      <div class="row margin-Top-3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Copyright-Element class="footer"></Copyright-Element>
        </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
    </div>
    <loader></loader>
    <error-page v-if="isUserGroupAdmin"></error-page>   
  </div>
</template>
<script>
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import MilestoneGridTab from '@/components/reports/milestone/MilestoneGridTab'
import MilestoneWiseFilterBar from '@/components/reports/milestone/MilestoneWiseFilterBar'
import ReportGroupFilterBar from '@/components/ReportGroupFilterBar'
import list from '@/pages/SortableList'
import CopyrightElement from '@/components/CopyrightElement'
import AlertBox from '@/components/AlertOverlay'
import ErrorPage from '@/pages/Error'
import { constants } from '@/utils/constants'
import { reportService } from '@/server-util/report-service'
import csvHelper from '@/utils/csv-helper'
import Loader from '@/components/dashboard/Loader'
import { participantService } from '@/server-util/participant-service'
export default {
  created: function () {
    this.checkUserErrorStatus()
  },
  data: function () {
    return {
      currentSelectedTab: 1,
      showAlertDialog: false,
      errorMsg: false,
      showSpinner: false,
      showExportButton: true,
      selectedGroupObj: null,
      selectedMilestoneInfoObj: null,
      selectedMilestoneTitleObj: null,
      columnAlias: [],
      columnRespKey: [],
      columnNameToShow: [],
      linkColumnNames: [],
      responseToPass: [],
      sortColumnNames: ['Name', 'Email', 'UserName'],
      showMilestoneList: false,
      reportArr: [],
      isViewBtnClicked: false,
      isExportBtnClicked: false
    }
  },
  components: {
    'milestone-grid-tab': MilestoneGridTab,
    'report-group-filter-bar': ReportGroupFilterBar,
    'milestone-wise-filter-bar': MilestoneWiseFilterBar,
    'sortable-list': list,
    'Copyright-Element': CopyrightElement,
    'alert-box': AlertBox,
    'error-page': ErrorPage,
    'loader': Loader
  },
  methods: {
    checkUserErrorStatus: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '') {
        participantService
          .getUserErrorStatus(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              const jsonObj = responseObj.data
              this.checkAndShowAlert(jsonObj)
            }
          }, errorObj => {
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('getUserErrorStatus Error :::' + this.errorMsg)
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING GET ERROR INFO'
        )
      }
    },
    checkAndShowAlert: function (jsonObj) {
      if (jsonObj !== undefined && jsonObj !== 'undefined' && jsonObj !== null && jsonObj !== 'null' && jsonObj !== '') {
        const isLoggedOut = jsonObj.IsAdminLoggedOut
        const profileError = jsonObj.ProfileError
        if (isLoggedOut) {
          this.showAlertDialog = true
          this.errorMsg = constants.Logged_Out_From_Another_Platform_Error_Msg
        } else if (profileError === constants.Change_Password_Error_Profile) {
          this.showAlertDialog = true
          this.errorMsg = constants.Change_Password_Alert_Msg
        }
      }
    },
    peformCleanUpOperationOnSignOut: function () {
      var store = this.$store
      var cookies = this.$cookies
      cookies.remove(constants.LOGIN_COOKIE_KEY)
      cookies.remove(constants.LOGIN_USER_COOKIE)
      store.state.isUserProfileLoaded = false
      localStorage.removeItem(constants.LOGIN_USER_COOKIE)
      localStorage.setItem('selectedMenu', 0)
      localStorage.setItem('selectedSubMenu', 0)
      localStorage.clear()
      this.$store.state.curr_user = null
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      switch (this.errorMsg) {
        case constants.Logged_Out_From_Another_Platform_Error_Msg:
          this.peformCleanUpOperationOnSignOut()
          break
        case constants.Change_Password_Alert_Msg:
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.EditProfile)
          this.$router.push('/profile?OpenPopUp=true')
          break
      }
    },
    selectedTab (value) {
      // AK: As soon as user changed Tab then hide report list
      if (parseInt(this.currentSelectedTab) !== value) {
        this.showMilestoneList = false
      }
      // AK: Update Currently selected Tab
      this.currentSelectedTab = value
    },
    setGroupObj (value) {
      // AK: When user selected particular Group object then update it in parent file too
      this.selectedGroupObj = value
    },
    setMilestoneInfoAndGroupObj (value) {
      // AK: When user selected particular MilestoneInfo, group and Milestone Title object then update it in parent file too
      this.selectedMilestoneInfoObj = value.selectedMilestoneInfoObj
      this.selectedGroupObj = value.selectedGroupObj
      this.selectedMilestoneTitleObj = value.selectedMilestoneTitleObj
    },
    updateViewBtnClickedFlag (value) {
      this.isViewBtnClicked = value
      if (value) {
        switch (parseInt(this.currentSelectedTab)) {
          case 1:
            this.getMilestoneInfoUsingGroup(false)
            break
          case 2:
            this.getMilestoneInfoUsingMilestoneAndGroup(false)
            break
        }
      }
    },
    exportCSV (value) {
      this.isExportBtnClicked = value
      if (value) {
        switch (parseInt(this.currentSelectedTab)) {
          case 1:
            this.getMilestoneInfoUsingGroup(true)
            break
          case 2:
            this.getMilestoneInfoUsingMilestoneAndGroup(true)
            break
        }
      }
    },
    getMilestoneInfoUsingGroup: function (needToExport = false) {
      var storeObj = this.$store
      var _this = this
      if (storeObj.state.access_token !== undefined || storeObj.state.access_token !== null || storeObj.state.access_token !== '') {
        _this.$store.state.isLoading = true
        reportService
          .getAchievedMilestoneUsingGroup(
            storeObj.state.access_token,
            this.selectedGroupObj.GroupId,
            needToExport,
            null
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.reportArr = responseObj.data.UserMilestones
              _this.$store.state.isLoading = false
              if (needToExport) {
                _this.csvFileName = 'GroupBasedMilestoneReport(' + this.selectedGroupObj.GroupName + ')'
                return csvHelper.exportFromServerData(responseObj.data, _this.csvFileName)
              } else {
                if (_this.reportArr.length === 0) {
                  _this.showMilestoneList = false
                  _this.showAlertDialog = true
                  _this.errorMsg = 'No reports found.'
                } else {
                  _this.addColumnAlias()
                }
              }
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING GROUP LIST'
        )
      }
    },
    getMilestoneInfoUsingMilestoneAndGroup: function (needToExport = false) {
      var storeObj = this.$store
      var _this = this
      if (storeObj.state.access_token !== undefined || storeObj.state.access_token !== null || storeObj.state.access_token !== '') {
        _this.$store.state.isLoading = true
        reportService
          .getAchievedMilestoneUsingMilestoneAndGroup(
            storeObj.state.access_token,
            this.selectedGroupObj.GroupId,
            this.selectedMilestoneInfoObj.MilestoneInfoId,
            needToExport,
            this.selectedMilestoneTitleObj
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.reportArr = responseObj.data.UserMilestones
              _this.$store.state.isLoading = false
              if (needToExport) {
                _this.csvFileName = 'GroupAndMilestoneBasedMilestoneReport(' + this.selectedGroupObj.GroupName + ' - ' + this.selectedMilestoneInfoObj.Title + ')'
                return csvHelper.exportFromServerData(responseObj.data, _this.csvFileName)
              } else {
                if (_this.reportArr.length === 0) {
                  _this.showMilestoneList = false
                  _this.showAlertDialog = true
                  _this.errorMsg = 'No reports found.'
                } else {
                  _this.addColumnAlias()
                }
              }
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING GROUP LIST'
        )
      }
    },
    addColumnAlias: function () {
      this.columnAlias = []
      switch (parseInt(this.currentSelectedTab)) {
        case 1:
          this.columnAlias = ['Name', 'Email', 'Username', 'Achieved Milestones']
          break
        case 2:
          this.columnAlias = ['Name', 'Email', 'Username', 'Milestone Title', 'Achieved On']
          break
      }
      this.addColumnRespKey()
    },
    addColumnRespKey: function () {
      this.columnRespKey = []
      switch (parseInt(this.currentSelectedTab)) {
        case 1:
          this.columnRespKey = ['Name', 'Email', 'UserName', 'AchievedMilestones']
          break
        case 2:
          this.columnRespKey = ['Name', 'Email', 'UserName', 'MilestoneTitle', 'AchievedOn']
          break
      }
      this.bindResponseObj()
    },
    bindResponseObj: function () {
      this.responseToPass = []
      for (var i = 0; i < this.reportArr.length; i++) {
        var dateToShow = ''
        var achievedMilestones = ''
        var milestoneTitle = ''
        if (this.currentSelectedTab === 1) {
          dateToShow = ''
          achievedMilestones = this.reportArr[i].AchievedMilestones
          milestoneTitle = ''
        } else {
          /* AK: if current selected Tab is 2 i.e. Milestonewise reports
          then format the date and show to each record */
          var dateToPass = this.reportArr[i].AchievedOn
          if (dateToPass.indexOf('Z') === -1) {
            dateToPass += 'Z'
          }
          dateToShow = dmAdminUtils.formatDateAndTimeWithOutTimeZone(dateToPass)
          achievedMilestones = ''
          milestoneTitle = this.reportArr[i].MilestoneTitle
        }
        var obj = {
          UserId: this.reportArr[i].UserId,
          Name: this.reportArr[i].Name,
          Email: this.reportArr[i].Email,
          UserName: this.reportArr[i].UserName,
          AchievedOn: dateToShow,
          MilestoneTitle: milestoneTitle,
          AchievedMilestones: achievedMilestones
        }
        this.responseToPass.push(obj)
      }
      this.bindColumnsNameAndAlias()
    },
    bindColumnsNameAndAlias: function () {
      this.columnNameToShow = []
      for (var i = 0; i < this.columnRespKey.length; i++) {
        var obj = {
          ColumnName: this.columnRespKey[i],
          ColumnAlias: this.columnAlias[i]
        }
        this.columnNameToShow.push(obj)
      }
      // console.log('Column And alias Name Obj >>>> ' + JSON.stringify(this.columnNameToShow))
      this.processAndExecuteSelectedOperation()
    },
    processAndExecuteSelectedOperation: function () {
      if ((!this.isExportBtnClicked) && this.isViewBtnClicked) {
        // AK: If export btn not clicked and list is shown previously then show list only
        this.showMilestoneList = true
      } else if (this.isExportBtnClicked && (!this.isViewBtnClicked)) {
        // AK: If user directly clicked on export button without clicking view first then export data
      } else if (this.isExportBtnClicked && this.isViewBtnClicked) {
        // AK: If user performed both operations then performed both operations
        this.showMilestoneList = true
      }
    }
  },
  computed: {
    isUserGroupAdmin: {
      get: function () {
        var userObj = this.$store.state.curr_user
        if (parseInt(userObj.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        } else {
          return false
        }
      }
    },
    getReportArr: {
      get: function () {
        return this.responseToPass
      }
    },
    getCurrentlySelectedTab: {
      get: function () {
        return this.currentSelectedTab
      }
    }
  },
  name: 'MilestoneReport'
}
</script>

<style scoped>
.MilestoneReport {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.border-red{
  border: 1px solid red;
}
.border-yellow{
  border: 2px solid yellow;
}
/* Using Only for footer */
.footer{
    /* position: fixed; */
    left: 38px !important;
    bottom: 0 !important;
    width: 100% !important;
    /* background-color: red; */
    /* color: white; */
    text-align: center !important;
    margin-bottom: 1% !important;
    font-size: 12px !important;
}
.margin-left-1point5Perc{
  margin-left:1.5% !important;
}
.margin-right-1point5Perc{
  margin-right:1.5% !important;
}
.width-97Point4{
  width:97.4% !important;
}
.milestoneList{
  min-height: 57vh;
}
</style>


// WEBPACK FOOTER //
// src/pages/MilestoneReport.vue